import { parseEinzelneEFNMitBeschriftung } from './efnBarcodeContentRecogniser';

export function isEFNinTeilnahmeMeldungen(efn, vnr, state){
	const punkteMeldungen = state.punkteMeldung.teilnahmeMeldungen[vnr]
	if(punkteMeldungen === undefined) return false;
	return findEFN(punkteMeldungen, efn) >= 0
}

function findEFN(jsonRows, efn){
	let foundIndex = -1;
	Object.values(jsonRows).some((jsonRow, index) => { 
		const matches = efn === jsonRow.efn
		if (matches) foundIndex = index;
		return matches; 
	});
	return foundIndex;
}

export function isEFNinErfasstenTeilnahmen(efn, vnr, state){
	if(state.punkteMeldung.erfassteTeilnahmen[vnr] === undefined) return false;
	return state.punkteMeldung.erfassteTeilnahmen[vnr][efn] !== undefined
}

const KEINE_BESCHRIFTUNG = { text: "" };

/**
 * Beschriftung zu einer EFN. Liefert immer ein Objekt, damit der Aufrufer nicht pruefen muss -
 * und bewusst dieselbe Instanz, solange nichts hinterlegt ist, damit connect() keine
 * unnoetigen Re-Renders ausloest.
 */
export function getBeschriftung(state, vnr, efn){
	const beschriftungenOfVNR = state.punkteMeldung.beschriftungen[vnr];
	if(beschriftungenOfVNR === undefined) return KEINE_BESCHRIFTUNG;
	return beschriftungenOfVNR[efn] || KEINE_BESCHRIFTUNG;
}

export function countBeschriftungen(state, vnr){
	const beschriftungenOfVNR = state.punkteMeldung.beschriftungen[vnr];
	return beschriftungenOfVNR === undefined ? 0 : Object.keys(beschriftungenOfVNR).length;
}

/**
 * Die EFN, die gerade im Eingabefeld steht - auch dann, wenn eine Beschriftung dahinter
 * steht. Ohne das wuerde der Hinweis "fuer diese EFN gibt es bereits Punktemeldung(en)"
 * verschwinden, sobald jemand einen Namen mit einscannt, und die zugehoerige Zeile im
 * Protokoll waere nicht mehr hervorgehoben.
 */
export function getEFNInEingabe(state, vnr){
	const eingabe = state.punkteMeldung.addTeilnahme[vnr].efn;
	const einzelne = parseEinzelneEFNMitBeschriftung(eingabe);
	return einzelne ? einzelne.efn : eingabe;
}

/**
 * Erfasste, noch nicht gemeldete Teilnahmen - mit vnr die dieser Veranstaltung, ohne vnr die
 * Summe ueber alle. Muss einen halb gefuellten Store aushalten: der Slice kann leer und der
 * Eintrag zur VNR undefined sein, und genau in dem Moment (frischer Start, Portal-Aufruf) wird
 * er gebraucht.
 */
export function countOffeneTeilnahmen(state, vnr){
	const erfasste = state.punkteMeldung.erfassteTeilnahmen || {};
	if(vnr !== undefined) return Object.keys(erfasste[vnr] || {}).length;
	return Object.values(erfasste).reduce((summe, teilnahmen) => summe + Object.keys(teilnahmen || {}).length, 0);
}
